// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorStop_container__3lhQE","active":"ColorStop_active__1uT9x"};